import { useSyncExternalStore } from 'react';
import { useChatStore } from '../stores/useChatStore';

let visible = false;
const listeners = new Set<() => void>();

function emitChange() {
  listeners.forEach((l) => l());
}

if (typeof window !== 'undefined') {
  window.addEventListener('keydown', (e) => {
    if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'a') {
      e.preventDefault();
      visible = !visible;
      // 同步 toggle showToolDetails
      useChatStore.getState().toggleShowToolDetails();
      emitChange();
    }
  });
}

function subscribe(callback: () => void) {
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
}

function getSnapshot() {
  return visible;
}

export function useTraceIdVisible() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
